import type { TRuleWithTheme } from '@/styles/theme';

export const link: TRuleWithTheme = () => ({
    wordBreak: 'break-word',
});
